module.exports = __webpack_public_path__ + "img/Group_27993.509fa5ef.svg";